import React from "react";

const Poland = () => {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 20 15"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        height="15"
        id="mask0_305_22691"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
        width="20"
        x="0"
        y="0"
      >
        <rect fill="white" height="15" width="20" />
      </mask>
      <g mask="url(#mask0_305_22691)">
        <path
          clipRule="evenodd"
          d="M0 0V15H20V0H0Z"
          fill="#F7FCFF"
          fillRule="evenodd"
        />
        <mask
          height="15"
          id="mask1_305_22691"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
          width="20"
          x="0"
          y="0"
        >
          <path
            clipRule="evenodd"
            d="M0 0V15H20V0H0Z"
            fill="white"
            fillRule="evenodd"
          />
        </mask>
        <g mask="url(#mask1_305_22691)">
          <path
            clipRule="evenodd"
            d="M0 7.5V15H20V7.5H0Z"
            fill="#C51918"
            fillRule="evenodd"
          />
        </g>
      </g>
      <rect height="14" rx="0.5" stroke="#E8E7E4" width="19" x="0.5" y="0.5" />
    </svg>
  );
};

export default Poland;
